/** Display-name format preference (stored in Clerk unsafeMetadata). */

export const DISPLAY_NAME_FORMATS = [
  { id: "first_last", label: "First Last" },
  { id: "first", label: "First only" },
  { id: "last", label: "Last only" },
  { id: "last_first", label: "Last First" },
];

export const DEFAULT_DISPLAY_NAME_FORMAT = "first_last";
export const DISPLAY_NAME_FORMAT_META_KEY = "displayNameFormat";

export const normalizeDisplayNameFormat = (value) => {
  const id = String(value || "").trim();
  return DISPLAY_NAME_FORMATS.some((opt) => opt.id === id)
    ? id
    : DEFAULT_DISPLAY_NAME_FORMAT;
};

export const getDisplayNameFormatFromUser = (user) =>
  normalizeDisplayNameFormat(user?.unsafeMetadata?.[DISPLAY_NAME_FORMAT_META_KEY]);

/**
 * Build a display name from first/last using the selected format.
 */
export const formatDisplayName = ({
  firstName = "",
  lastName = "",
  format = DEFAULT_DISPLAY_NAME_FORMAT,
  fallback = "User",
} = {}) => {
  const first = String(firstName || "").trim();
  const last = String(lastName || "").trim();
  const mode = normalizeDisplayNameFormat(format);

  let value = "";
  switch (mode) {
    case "first":
      value = first;
      break;
    case "last":
      value = last;
      break;
    case "last_first":
      value = [last, first].filter(Boolean).join(" ");
      break;
    case "first_last":
    default:
      value = [first, last].filter(Boolean).join(" ");
      break;
  }

  return value || fallback;
};

/** Resolve display name for a Clerk user object. */
export const getUserDisplayName = (user, fallback = "User") => {
  if (!user) return fallback;
  return formatDisplayName({
    firstName: user.firstName,
    lastName: user.lastName,
    format: getDisplayNameFormatFromUser(user),
    fallback:
      user.primaryEmailAddress?.emailAddress ||
      fallback,
  });
};

/** Preview label for format options using current first/last. */
export const previewDisplayNameFormat = (firstName, lastName, formatId) => {
  const preview = formatDisplayName({
    firstName,
    lastName,
    format: formatId,
    fallback: "",
  });
  if (preview) return preview;
  const option = DISPLAY_NAME_FORMATS.find((opt) => opt.id === formatId);
  return option?.label || formatId;
};
